var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top20 bottom60"},[_c('dropper',{attrs:{"index":_vm.index,"level":2}}),(_vm.$parent.editMode)?_c('div',{staticClass:"delete is-pulled-right",on:{"click":_vm.remove}}):_vm._e(),_c('div',{class:{'top40': _vm.$parent.editMode}},[_c('wideBundleDrop')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }